<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M12.5 13.25C12.5 13.6641 12.8359 14 13.25 14C13.6641 14 14 13.6641 14 13.25V11.75C14 11.3359 13.6641 11 13.25 11C12.8359 11 12.5 11.3359 12.5 11.75V13.25Z"
            fill="currentColor"
        />
        <path
            d="M6.75 14C6.3359 14 6 13.6641 6 13.25V9.25C6 8.8359 6.3359 8.5 6.75 8.5C7.1641 8.5 7.5 8.8359 7.5 9.25V13.25C7.5 13.6641 7.1641 14 6.75 14Z"
            fill="currentColor"
        />
        <path
            d="M9.25 13.25C9.25 13.6641 9.5859 14 10 14C10.4141 14 10.75 13.6641 10.75 13.25V6.75C10.75 6.3359 10.4141 6 10 6C9.5859 6 9.25 6.3359 9.25 6.75V13.25Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 2.25C3.92893 2.25 2.25 3.92893 2.25 6V14C2.25 16.0711 3.92893 17.75 6 17.75H14C16.0711 17.75 17.75 16.0711 17.75 14V6C17.75 3.92893 16.0711 2.25 14 2.25H6ZM3.75 6C3.75 4.75736 4.75736 3.75 6 3.75H14C15.2426 3.75 16.25 4.75736 16.25 6V14C16.25 15.2426 15.2426 16.25 14 16.25H6C4.75736 16.25 3.75 15.2426 3.75 14V6Z"
            fill="currentColor"
        />
    </svg>
</template>
